import { Controller } from "@hotwired/stimulus";
import { blurFocusedPicker } from "../lib/blur_picker";

// Submits the form it is attached to. Declare the trigger at the call site,
// e.g. data-action="change->turbo-form-submit#submit" for auto-saving forms.
export default class extends Controller {
  submit() {
    // A focused tom-select would be refocused by Turbo when this form's own
    // response replaces the region it lives in, reopening its dropdown.
    blurFocusedPicker();

    // requestSubmit() respects Turbo's data attributes and form configuration
    this.element.requestSubmit();
  }
}
